var excel = "https://shopfront-cdn.tekoapis.com/static/56ef3890145be03a.svg";

export { excel as default };
